import React from 'react';
import styled from 'styled-components';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Link from '@material-ui/core/Link';
import { getElementFields } from '../../forms/utils/getElementFields';
import { SmartformElementData } from '../../types';
import { getHref } from '../../atoms/ReadOnly/ReadOnly';
import { InfoText } from '../../atoms/InfoText/InfoText';

const StyledHelpText = styled.div`
  margin-top: 8px;
  font-size: 14px;
`;
const StyledLink = styled.div`
  margin: 1rem 0;
`;

export const LinkField: React.FC<SmartformElementData> = (props) => {
  const [linkField] = getElementFields(props).required;
  const label = props.element.params?.linkLabel || 'Click Here';
  return (
    <FormControl fullWidth>
      <InputLabel
        htmlFor={`${linkField.name}-field-label`}
        data-test={`${linkField.name}-field-label`}
        style={{ top: 0, position: 'relative' }}
        shrink
      >
        <InfoText label={linkField.label} required={linkField.validation.required} tooltipText={linkField.infoText} />
      </InputLabel>
      {linkField.helpText && (
        <StyledHelpText
          style={{ marginTop: 2 }}
          data-test={`${linkField.name}-field-helper`}
          id={`${linkField.name}-helper-text`}
        >
          {linkField.helpText}
        </StyledHelpText>
      )}
      <StyledLink data-test={`${linkField.name}-field-anchor`}>
        <Link id={`${linkField.name}-field-label`} target="__blank" href={getHref(linkField.initialValue)}>
          {label}
        </Link>
      </StyledLink>
    </FormControl>
  );
};
